/* ==========================================================================
   INFINITE MARQUEE SHORTCUT TICKER (ts/marquee.ts)
   ========================================================================== */

export function initMarqueeTicker(marqueeId: string): void {
  const marqueeContainer = document.getElementById(marqueeId);
  if (!marqueeContainer) return;

  const track = marqueeContainer.querySelector<HTMLElement>('.marquee-track');
  if (!track) return;

  // Duplicate items for seamless continuous looping
  const originalContent = track.innerHTML;
  track.innerHTML = originalContent + originalContent;
}
